import { useSyncExternalStore } from "react";

// Shared "Enable debug" flag, toggled from the settings Overview page.
// Defaults to off and is persisted in localStorage so the choice survives reloads.
const STORAGE_KEY = "financeDebugEnabled";
const listeners = new Set<() => void>();

function read(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
}

export function setDebugEnabled(enabled: boolean) {
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? "true" : "false");
  } catch {
    // Ignore storage failures (e.g. private mode); the in-memory listeners still fire.
  }
  listeners.forEach((listener) => listener());
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  const onStorage = (event: StorageEvent) => {
    if (event.key === STORAGE_KEY) listener();
  };
  window.addEventListener("storage", onStorage);
  return () => {
    listeners.delete(listener);
    window.removeEventListener("storage", onStorage);
  };
}

export function useDebugEnabled(): boolean {
  return useSyncExternalStore(subscribe, read, () => false);
}
